// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "aee06ea";
